import {Component, Input} from '@angular/core';
import {TranslateModule} from "@ngx-translate/core";
import {MatIcon} from '@angular/material/icon';
import {MatAnchor} from '@angular/material/button';
import {DatePipe, NgIf} from '@angular/common';
import {MatCard} from '@angular/material/card';

@Component({
    selector: 'headline-text',
    templateUrl: './headline-text.component.html',
    styleUrls: ['./headline-text.component.scss'],
    standalone: true,
    imports: [MatCard, NgIf, MatAnchor, MatIcon, DatePipe, TranslateModule]
})
export class HeadlineTextComponent {

  @Input() headline!: string;
  @Input() text!: string;
}
